enum BookingsOverviewDateType {
  Any = 'Any',
  CheckIn = 'CheckIn',
  CheckOut = 'CheckOut',
  DateBooked = 'DateBooked',
  StayDate = 'StayDate',
}

export default BookingsOverviewDateType;
